import { createBrowserRouter, RouterProvider, useParams, useLocation, useNavigate } from "react-router-dom";
import Route from "./view/Route";
import { ToastContainer } from 'react-toastify';
function App() {
  return (
    <>
      <ToastContainer />
      <RouterProvider router={createBrowserRouter([...Route])} />
    </>
  );
}

export default App;
